

import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://dnqvwmqydphyvignhxti.supabase.co'
const supabaseKey = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRucXZ3bXF5ZHBoeXZpZ25oeHRpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzU3NjMzNDcsImV4cCI6MjA1MTMzOTM0N30.nbr93w-8L1EteFeI-T0WVeDWxjHwr3Lommv6vWNFHIM`;
const supabase = createClient(supabaseUrl, supabaseKey);

export const getTransactions = async (startDate: string, endDate: string, callback: (result: any)=>void, errorCallback: () => void ) => {
    const queryResult = await supabase
        .from('DeedTransfer')
        .select("*, Parcel(streetAddress, parcelType, acres, city, marketArea, neighborhood, zip)")
        .gte("saleDate", startDate)
        .lte("saleDate", endDate)
        .in('Parcel.parcelType', [81, 82])
        .order('saleDate', { ascending: true })

    if (queryResult.data != null) {
        const filteredResult = queryResult.data?.filter(row => row.Parcel !== null);
        callback(filteredResult); 
    } else {
        errorCallback();
    }
}

export const getSaleHistory = async (parcelNumber: string, callback: (result: any)=>void, errorCallback: () => void ) => {
    const queryResult = await supabase
        .from('DeedTransfer')
        .select("*")
        .eq("parcelNumber", parcelNumber)
        .order('saleDate', { ascending: false })

    if (queryResult.data != null) {
        callback(queryResult.data); 
    } else {
        errorCallback();
    }
}